// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__WJTOA","fileBtn":"File_fileBtn__3Kf1U","closeBtn":"File_closeBtn__iVZiR","fileSelected":"File_fileSelected__h_V2r","disabled":"File_disabled__tQI-5"};